"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redirectToLogin = void 0;
exports.validateUser = validateUser;
exports.refressTokenListener = refressTokenListener;
exports.handleLoginRequest = handleLoginRequest;
exports.handleLoginSuccess = handleLoginSuccess;
exports.handleExchange = handleExchange;
exports.handleExchangeFailure = handleExchangeFailure;
exports.handleFirstTimeLogin = handleFirstTimeLogin;
exports.refreshTokenSuccess = refreshTokenSuccess;
exports.refreshTokenFailure = refreshTokenFailure;
exports.cancelUpload = cancelUpload;
exports.handleLogout = handleLogout;
exports.listenInvalidTokenActions = listenInvalidTokenActions;
exports.fetchUserLanguage = fetchUserLanguage;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var redux_observable_1 = require("redux-observable");
var connected_react_router_1 = require("connected-react-router");
var translations_1 = require("@caddigital/sok-reducers/lib/actions/translations");
var cookies_1 = require("utils/cookies");
var translate_1 = require("utils/translate");
var login_1 = require("@caddigital/sok-reducers/lib/actionTypes/auth/login");
var current_1 = require("@caddigital/sok-reducers/lib/actionTypes/auth/current");
var login_2 = require("@caddigital/sok-reducers/lib/actions/auth/login");
var current_2 = require("@caddigital/sok-reducers/lib/actions/auth/current");
var form_1 = require("@caddigital/sok-reducers/lib/actionTypes/firstLogin/form");
var fileUploadModal_1 = require("actions/fileUploadModal");
var langPattern = "/([\\w]{2})";
var whitelist = [
    '^/authorizing',
    '^/authorize',
    '^/sso/([.]*)',
    "^".concat(langPattern, "/login"),
    "^".concat(langPattern, "/logout"),
    "^".concat(langPattern, "/forgotpassword"),
    "^".concat(langPattern, "/resetpassword"),
    "^".concat(langPattern, "/verify-jwt"),
    "^".concat(langPattern, "/verify-account"),
    "^".concat(langPattern, "/change-password"),
    "^".concat(langPattern, "/sso")
].concat(__SOKOBID_PORTAL__ ? ["^".concat(langPattern, "/register")] : []);
var isAllowed = function () {
    return whitelist.filter(function (url) {
        var pattern = new RegExp(url);
        return pattern.test(location.pathname);
    });
};
var logoutUrl = function () {
    var clientDomain = (0, cookies_1.getCookie)('client_domain');
    var params = {
        logout_uri: "".concat(__SSO_REDIRECT__),
        client_id: (0, cookies_1.getCookie)('client_id')
    };
    var search = Object.entries(params)
        .map(function (_a) {
        var k = _a[0], v = _a[1];
        return "".concat(k, "=").concat(encodeURIComponent(v || ''));
    })
        .join('&');
    (0, cookies_1.removeCookie)('client_id');
    (0, cookies_1.removeCookie)('client_domain');
    (0, cookies_1.removeCookie)('federated_user');
    return "https://".concat(clientDomain, ".auth.eu-west-1.amazoncognito.com/logout?").concat(search);
};
var redirectToLogin = function () {
    if (__DISABLE_LOGIN__) {
        return (0, rxjs_1.empty)();
    }
    var currentLanguage = (0, translate_1.getLanguage)();
    var url = window.location.pathname;
    var search = window.location.search;
    if (isAllowed().length === 0) {
        (0, cookies_1.setCookie)('address_before_login', url + search);
    }
    return (0, rxjs_1.of)((0, connected_react_router_1.replace)("/".concat(currentLanguage, "/login")));
};
exports.redirectToLogin = redirectToLogin;
/**
 * Validate login status on each request and URL change.
 *
 * If accessToken is presented, try to refresh token.
 * 1. Do nothing when token expiration is longer than 5 minutes.
 * 2. Refresh token when token expiration is less than 5 minutes but not expired.
 * 3. Failed when token has expired. Redirect to login page.
 *
 * If accessToken is missing, and the URL is not in whitelist, redirect to login
 * page.
 */
function validateUser(action$, store) {
    return action$.pipe((0, operators_1.filter)(function (action) {
        return (!action.type.startsWith('@sok/auth') &&
            action.type.startsWith('@sok/')) ||
            action.type === connected_react_router_1.LOCATION_CHANGE;
    }), (0, operators_1.mergeMap)(function () {
        var token = store.value.auth.current.token;
        if (token && token.length > 0) {
            return (0, rxjs_1.empty)();
        }
        else if (isAllowed().length === 0) {
            return (0, exports.redirectToLogin)();
        }
        return (0, rxjs_1.empty)();
    }));
}
function debounceByAction(delay) {
    var source$ = this;
    return new rxjs_1.Observable(function (observer) {
        var lastSeen = 0;
        return source$
            .pipe((0, operators_1.debounce)(function (value) {
            var time = Date.now() - lastSeen;
            if (time < delay) {
                return (0, rxjs_1.timer)(delay);
            }
            else {
                lastSeen = Date.now();
                // This will complete() right away so we don't actually debounce/buffer
                // it at all
                return (0, rxjs_1.empty)();
            }
        }))
            .subscribe(observer);
    });
}
// Refresh delay 10 min
var refreshDelay = 10 * 60 * 1000;
function refressTokenListener(action$, store) {
    return action$.pipe((0, operators_1.filter)(function (action) { return /REFRESH_TOKEN/.test(action.type) === false; }), function (source$) { return debounceByAction.call(source$, refreshDelay); }, (0, operators_1.mergeMap)(function () {
        var token = store.value.auth.current.token;
        if (token && token.length > 0) {
            return (0, rxjs_1.of)((0, current_2.refreshTokenRequestAction)());
        }
        return (0, rxjs_1.empty)();
    }));
}
function handleLoginRequest(action$) {
    return action$.ofType(login_1.LOGIN_REQUEST).pipe((0, operators_1.mergeMap)(function () {
        (0, cookies_1.removeCookie)('client_id');
        (0, cookies_1.removeCookie)('client_domain');
        (0, cookies_1.removeCookie)('federated_user');
        return (0, rxjs_1.empty)();
    }));
}
function handleLoginSuccess(action$) {
    return action$.ofType(login_1.LOGIN_SUCCESS).pipe((0, operators_1.mergeMap)(function (action) {
        (0, cookies_1.setCookie)('token', action.payload, 8);
        var currentLanguage = (0, translate_1.getLanguage)();
        var addressBeforeLogin = (0, cookies_1.getCookie)('address_before_login');
        return (0, rxjs_1.of)((0, connected_react_router_1.replace)(addressBeforeLogin ? addressBeforeLogin : "/".concat(currentLanguage, "/")));
    }));
}
function handleExchange(action$) {
    return action$.ofType(login_1.EXCHANGE_CODE_FOR_TOKENS_SUCCESS).pipe((0, operators_1.mergeMap)(function (action) {
        (0, cookies_1.setCookie)('token', action.payload, 8);
        var addressBeforeLogin = (0, cookies_1.getCookie)('address_before_login');
        var currentLanguage = (0, translate_1.getLanguage)();
        (0, cookies_1.removeCookie)('address_before_login');
        return (0, rxjs_1.of)((0, connected_react_router_1.replace)(addressBeforeLogin ? addressBeforeLogin : "/".concat(currentLanguage)));
    }));
}
function handleExchangeFailure(action$) {
    return action$.pipe((0, operators_1.filter)(function (x) { return x.type === login_1.EXCHANGE_CODE_FOR_TOKENS_FAILURE; }), (0, operators_1.mergeMap)(function () {
        (0, cookies_1.removeCookie)('client_id');
        (0, cookies_1.removeCookie)('client_domain');
        (0, cookies_1.removeCookie)('federated_user');
        return (0, rxjs_1.empty)();
    }));
}
function handleFirstTimeLogin(action$) {
    return action$.ofType(form_1.SUBMIT_FIRST_LOGIN_SUCCESS).pipe((0, operators_1.mergeMap)(function () {
        var currentLanguage = (0, translate_1.getLanguage)();
        return (0, rxjs_1.merge)((0, rxjs_1.of)((0, current_2.getUserinfoRequestAction)()), (0, rxjs_1.of)((0, current_2.fetchUserFeaturesRequest)()), (0, rxjs_1.of)((0, connected_react_router_1.replace)("/".concat(currentLanguage))));
    }));
}
function refreshTokenSuccess(action$) {
    return action$.ofType(current_1.REFRESH_TOKEN_SUCCESS).pipe((0, operators_1.mergeMap)(function (action) {
        (0, cookies_1.setCookie)('token', action.payload, 8);
        return (0, rxjs_1.empty)();
    }));
}
function refreshTokenFailure(action$, store) {
    return action$.pipe((0, operators_1.filter)(function (action) { return action.type === current_1.REFRESH_TOKEN_FAILURE; }), (0, operators_1.mergeMap)(function (action) {
        if (isAllowed().length === 0 && !__DISABLE_LOGIN__) {
            if (action.payload && action.payload.type === 'BAD_REQUEST') {
                (0, cookies_1.removeCookie)('token');
                if ((0, cookies_1.getCookie)('federated_user') === 'true' &&
                    (0, cookies_1.getCookie)('ignore_redirect') !== 'true') {
                    window.location.href = logoutUrl();
                    var currentLanguage = (0, translate_1.getLanguage)();
                    return (0, rxjs_1.of)((0, connected_react_router_1.push)("/".concat(currentLanguage, "/logout")));
                }
                return (0, exports.redirectToLogin)();
            }
        }
        return (0, rxjs_1.empty)();
    }));
}
function cancelUpload(action$, store) {
    return action$.ofType(login_1.LOGOUT).pipe((0, operators_1.mergeMap)(function () {
        var state = store.value;
        if (Object.keys(state.fileUploadModal.uploadedFiles).length > 0) {
            return (0, rxjs_1.of)(fileUploadModal_1.default.fileUploadCancelAction(state.fileUploadModal.currentUploadStatus.session));
        }
        return (0, rxjs_1.empty)();
    }));
}
function handleLogout(action$, store) {
    return action$.ofType(login_1.LOGOUT).pipe((0, operators_1.mergeMap)(function () {
        var currentLanguage = (0, translate_1.getLanguage)();
        (0, cookies_1.removeCookie)('token');
        // If user is federeted then we will redirect user to login page
        // otherwise we only redirect user to our main page
        if ((0, cookies_1.getCookie)('federated_user') === 'true' &&
            (0, cookies_1.getCookie)('ignore_redirect') !== 'true') {
            window.location.href = logoutUrl();
            return (0, rxjs_1.of)((0, connected_react_router_1.push)("/".concat(currentLanguage, "/logout")));
        }
        return (0, rxjs_1.of)((0, connected_react_router_1.replace)("/".concat(currentLanguage, "/")));
    }));
}
function listenInvalidTokenActions(action$) {
    return action$.pipe((0, operators_1.filter)(function (action) { return /(FAILURE|FAILED)$/.test(action.type); }), (0, operators_1.mergeMap)(function (action) {
        if (typeof action.payload === 'object') {
            if (action.payload.type === 'INVALID_TOKEN') {
                var url = window.location.pathname;
                if (isAllowed().length === 0 && !__DISABLE_LOGIN__) {
                    (0, cookies_1.removeCookie)('token');
                    (0, cookies_1.setCookie)('address_before_login', url);
                }
                return (0, rxjs_1.of)((0, login_2.logout)());
            }
        }
        return (0, rxjs_1.empty)();
    }));
}
function fetchUserLanguage(action$) {
    return action$.pipe((0, operators_1.filter)(function (action) { return action.type === current_1.GET_USERINFO_SUCCESS; }), (0, operators_1.mergeMap)(function (action) {
        if (action.payload.language !== (0, translate_1.getLanguage)() &&
            action.payload.language !== undefined) {
            (0, translate_1.setLanguage)(action.payload.language);
            return (0, rxjs_1.of)((0, translations_1.fetchLanguageRequest)(action.payload.language));
        }
        return (0, rxjs_1.empty)();
    }));
}
exports.default = (0, redux_observable_1.combineEpics)(validateUser, handleLoginRequest, handleLoginSuccess, handleLogout, cancelUpload, refressTokenListener, refreshTokenSuccess, refreshTokenFailure, handleFirstTimeLogin, handleExchange, handleExchangeFailure, listenInvalidTokenActions, fetchUserLanguage);
